// extracted by mini-css-extract-plugin
export default {"returnButton":"ReturnButton_returnButton__ngGOK"};